import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faHeadset } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useSupportUrl, SUPPORT_FACEBOOK_ENABLED } from '../hooks/useSupportUrl';

export default function BannedPopup({ onDismiss }: { onDismiss: () => void }) {
  const { t } = useTranslation();
  const supportUrl = useSupportUrl();
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 28,
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: '#1e293b',
          borderRadius: 20,
          padding: 32,
          width: '100%',
          maxWidth: 420,
          textAlign: 'center',
          border: '1px solid #7f1d1d',
        }}
      >
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: 40,
            backgroundColor: '#450a0a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
          }}
        >
          <FontAwesomeIcon icon={faBan} style={{ color: '#ef4444', fontSize: 42 }} />
        </div>
        <div style={{ fontSize: 22, fontWeight: 900, color: '#f8fafc', marginBottom: 12 }}>
          {t('components.bannedPopup.title')}
        </div>
        <div style={{ fontSize: 14, color: '#94a3b8', marginBottom: 28, lineHeight: 1.55 }}>
          {t('components.bannedPopup.message')}
        </div>
        {SUPPORT_FACEBOOK_ENABLED ? (
          <button
            onClick={() => window.open(supportUrl, '_blank', 'noopener')}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              backgroundColor: '#14f1d1',
              color: '#020617',
              padding: '14px 24px',
              borderRadius: 999,
              border: 'none',
              fontSize: 15,
              fontWeight: 800,
              cursor: 'pointer',
            }}
          >
            <FontAwesomeIcon icon={faHeadset} />
            {t('components.bannedPopup.contactSupport')}
          </button>
        ) : null}
        <div>
          <button
            onClick={onDismiss}
            style={{
              marginTop: 12,
              padding: '10px 20px',
              background: 'transparent',
              border: 'none',
              color: '#94a3b8',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {t('actions.close')}
          </button>
        </div>
      </div>
    </div>
  );
}
